<template lang="html">
  <div class="d-flex flex-column" style="min-width:1300px; height: 80vh;">
    <div class="page-title-container">
      <div class="row">
        <div class="col-12 col-md-8 mb-3 mb-md-0 me-auto">
          <h1 class="mb-0 pb-0 display-4" id="title">Rapport d'import de fichiers</h1>
        </div>
        <div class="col-12 col-md-4 d-flex align-items-end justify-content-end">
          <button
              type="button"
              class="btn btn-outline-primary dropdown-toggle dropdown-toggle-split"
              data-bs-offset="0,3"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
          >
            <i class="fa icon-15 bi-download" data-acorn-icon="download" data-acorn-size="15"
               data-acorn-stroke-width="1.5"></i>
            <span class="me-2 ms-2">Exporter les avis</span>
          </button>
          <div class="dropdown-menu dropdown-menu-end p-3">
            <div class="input-daterange input-group d-flex flex-column" id="datePickerRange">
              <label class="top-label mb-2">
                <input type="date" class="form-control" name="start" v-model="export_date_begin"/>
                <span>Date début</span>
              </label>
              <label class="top-label mb-2">
                <input type="date" class="form-control" name="end" v-model="export_date_end"/>
                <span>Date fin</span>
              </label>
            </div>
            <a :href="review_export_data_link" target="_blank">
              <button class="btn btn-outline-primary w-100" type="button">Exporter la sélection</button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <ImportReportList/>
  </div>
</template>

<script>
import settings from '@/settings.coffee'
import AVATAR_UPLOAD from '@/gql/mutations/avatarUpload.graphql'
import { gqlMutation } from '@/gqlClient.js'
import MessagesList from '@/components/MessagesList.vue'
import ImportReportList from '@/components/ImportReportList.vue'

export default {
  name: 'profile',
  components: { MessagesList, ImportReportList },
  data() {
    return {
      export_date_begin: null,
      export_date_end: null
    };
  },
  computed: {
    review_export_data_link() {
      return (
        settings.review_export_data_url +
        `?from=${this.export_date_begin}&to=${this.export_date_end}`
      );
    },
    avatar_url() {
      return settings.backendUrl + this.$store.state.profile.data.avatar;
    },
    can_see_actions() {
      return this.$store.state.profile.groups.includes('managers');
    }
  },
  methods: {
    messageReceived(raw_message) {
      // rien à faire
    },
    upload_avatar(image) {
      if (!image) return;
      const self = this;
      const reader = new FileReader();
      reader.onload = function (aImg) {
        gqlMutation(AVATAR_UPLOAD, {
          uid: self.$store.state.profile.data.uid,
          imgdata: aImg.target.result,
          imgFileName: image.name
        }).then((res) => {
          if (res.ok) {
            self.$http.post(settings.authApiUrl).then((subdata) => {
              if (subdata.body.status === 'loggedin') {
                self.$store.dispatch('set_authenticated', subdata.body.profile);
              }
            });
          }
        });
      };
      reader.readAsDataURL(image);
    },
    filesChanged(arg, arg2, arg3) {
      const self = this;
      if (arg2[0].size < 200000) {
        self.upload_avatar(arg2[0]);
      } else {
        self.$store.dispatch('notify', {
          level: 'danger',
          text: 'Cet image est trop lourde'
        });
      }
    }
  },
  mounted() {
    // rien à faire
  }
}
</script>

<style scoped>
li {
  margin-bottom: 10px;
}

.clickable {
  cursor: pointer;
}

.input-file {
  opacity: 0;
  width: 40px;
  height: 32px;
  margin-left: -35px;
  padding-top: 10px;
  border: 1px solid red;
  cursor: pointer;
}

</style>

<style scoped>
.card {
  border-radius: 0.25rem;
}
</style>
